import React from 'react';
import {connect} from 'react-redux'
import {reduxForm} from 'redux-form/immutable';
import { Alert, Button } from 'antd';
import StudParentalStatus from "./ParentalStatusSurveyForm/StudParentalStatus";
import FathParentalStatus from "./ParentalStatusSurveyForm/FathParentalStatus";
import MonParentalStatus from "./ParentalStatusSurveyForm/MonParentalStatus";
import {fromJS} from 'immutable';

const formFieldsetStyle = {
    border: 0,
    margin: 0,
    padding: 0,
    minWidth: 0,
};

let ParentalStatusSurveyForm = props => {
    const { handleSubmit, isLocked } = props;
    return (
        <form onSubmit={isLocked ? undefined : handleSubmit} noValidate>
            {isLocked && (
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: '16px' }}
                    message="此表單已由註冊組鎖定，請聯繫註冊組開啟後再修改。"
                />
            )}
            <fieldset disabled={isLocked} style={formFieldsetStyle}>
                <div className='ml-20'>
                    <h3>
                        明道普霖斯頓雙語小學每年為配合教育部各項調查，敬請家長提供正確訊息。凡學生本人之身份為軍公教遺族、低收入戶、領有身心障礙手冊或原住民等，本校均可為該生申請相關教育部補助，敬請家長主動告知。補助金額及申請日期，依政府規定，按時辦理申報。
                    </h3>
                    <StudParentalStatus/>
                    <FathParentalStatus/>
                    <MonParentalStatus/>
                </div>
            </fieldset>
            <Button htmlType="submit" type={'primary'} size={'large'} disabled={isLocked} style={{width: '100%', marginTop: '10px'}}>
                {isLocked ? '已鎖定' : '送出'}
            </Button>
            <br/>
            <br/>
            <br/>
        </form>
    )
}

ParentalStatusSurveyForm = reduxForm({
    form: 'edit_ParentalStatusSurvey', // a unique identifier for this form
    enableReinitialize: true,
})(ParentalStatusSurveyForm)

ParentalStatusSurveyForm = connect(
    state => {
        const data = state.getIn(['ParentalStatusSurveyReducers', 'data']);
        const safeData = data && data.toJS ? data.toJS() : (data || {});
        return {
            initialValues: fromJS(safeData),
            isLocked: !!safeData.ques_check,
        };
    },
)(ParentalStatusSurveyForm)
export default ParentalStatusSurveyForm



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ParentalStatusSurveyContaioner/ParentalStatusSurveyForm.jsx